import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import Screen from "../shared/screen";
import "./style.css";
import { axiosInstance } from "../../config/apiTemplate";
import Skeleton from "@mui/material/Skeleton";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { stripCommaToNum } from "../shared/util";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { EtTable } from "../shared/table/table";
import { DataGridPro,GridToolbarContainer,GridToolbarColumnsButton,GridToolbarFilterButton,GridToolbarExport,GridToolbarDensitySelector, GridOverlay } from "@mui/x-data-grid-pro";
import LinearProgress  from "@mui/material/LinearProgress";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';

am4core.useTheme(am4themes_animated);

function SavingsPage() {
  const cashRatioChart = useRef(null);
  const navChart = useRef(null);
  const [toggles, setToggle] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [isLoading, setLoading] = useState(true);
  const [portfolio, setPortfolio] = useState(localStorage.getItem("t_id"));
  const [dashboard, setDashboard] = useState({
    top_shareholdings: [],
    latest_trades: [],
    latest_dividends: [],
    chart_data: [],
    portfolio_cash_ratio: { cash: 10, stocks: 100 },
    daily_change: {
      klci_change_perc: 0,
      portfolio_change: 0,
      portfolio_change_perc: 0,
      today_value: 0,
      yesterday_value: 0,
    },
  });
  const [aggregatedData, setAggregatedData] = useState({
    initialTpv:0,
    currentTpv:0,
    abs_return:0,
    abs_return_percentage:0,
    aggregatedTPV:[],
    unconfirmed_deposit:0
  });
  const [deposits, setDeposits] = useState("0");
  const [cashBalance, setCashBalance] = useState("0");
  const [mmInterest, setMmInterest] = useState("0");
  const [floatingBalance, setFloatingBalance] = useState("0");
  const [mmInterestLogs, setMmInterestLogs] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [withdrawalRequests, setWithdrawalRequests] = useState([]);
  const [withdrawalBalance, setWithdrawalBalance] = useState({
    cash_balance: "0",
    cash_balance_raw: 0
  });
  const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [withdrawError, setWithdrawError] = useState("");
  const [status, setStatus] = useState({
    boi_summary: []
  });
  let [tabIndex, setTabIndex] = useState(0);
  let productView = localStorage.getItem("productView");
  let client_code = localStorage.getItem("clientCode");

  useEffect(() => {
    document.title = "ETSW - Portfolio Dashboard";

    // Sleep 1 second
    setTimeout(() => {
      // getDashboardData();
      // getAggregatedData();
      // getStatus();
      getStats();
      getWithdrawalRequests();
      getWithdrawalBalance();
    }, 1000);

    // getDashboardData();
    // getAggregatedData();
  }, []);

  //  API ========================================================================================================================

  async function getStats(){
    const url = "client_api/savings/getStats_v2.php";

    let statsForm = new FormData();
    statsForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, statsForm);
      if(response.data.status === 201){
        setDeposits(response.data.deposits);
        setCashBalance(response.data.cash_balance);
        setMmInterest(response.data.mm_interest);
        setMmInterestLogs(response.data.mm_interest_logs);
        setStrategies(response.data.strategies);
        setFloatingBalance(response.data.pending_approval);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function getWithdrawalRequests(){
    const url = "client_api/savings/getWithdrawalRequests.php";

    let withdrawalRequestsForm = new FormData();
    withdrawalRequestsForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, withdrawalRequestsForm);
      if(response.data.status === 201){
        setWithdrawalRequests(response.data.withdrawal_requests);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function getWithdrawalBalance(){
    const url = "client_api/savings/getWithdrawalBalance.php";

    let withdrawalBalanceForm = new FormData();
    withdrawalBalanceForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, withdrawalBalanceForm);
      if(response.data.status === 201){
        setWithdrawalBalance({
          cash_balance: response.data.cash_balance,
          cash_balance_raw: response.data.cash_balance_raw
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function submitWithdrawalRequest(amount){
    const url = "client_api/savings/submitWithdrawalRequest.php";

    let submitWithdrawalRequestForm = new FormData();
    submitWithdrawalRequestForm.append("client_code", client_code);
    submitWithdrawalRequestForm.append("amount", amount);

    try {
      const response = await axiosInstance.post(url, submitWithdrawalRequestForm);
      if(response.data.status === 201){
        window.alert("Withdrawal request submitted successfully");
        getWithdrawalRequests();
        getWithdrawalBalance();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function deleteWithdrawalRequest(id){
    const url = "client_api/savings/deleteWithdrawalRequest.php";
    let deleteWithdrawalRequestForm = new FormData();
    deleteWithdrawalRequestForm.append("id", id);
    deleteWithdrawalRequestForm.append("client_code", client_code);
    try {
      const response = await axiosInstance.post(url, deleteWithdrawalRequestForm);
      if(response.data.status === 201){
        window.alert("Withdrawal request deleted successfully");
        getWithdrawalRequests();
        getWithdrawalBalance();
      }
    } catch (e) {
      console.log(e);
    }
  }

  //  FUNCTIONS ========================================================================================================================

  function getTotalShareholdings() {
    if (dashboard.top_shareholdings.length > 0)
      return dashboard.top_shareholdings
        .reduce((a, b) => a + Number(b.portfolio_percent), 0)
        .toFixed(2);

    return 0;
  }

  // RENDER FUNCTIONS  ========================================================================================================================\

  function prepareTableRows(){
    return mmInterestLogs.map((item,index)=>{
      return {...item,no:(index+1),id:index};
    });
  }

  function loadingOverlay(){
    return(
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
            <LinearProgress />
            </div>
        </GridOverlay>
    )
  }

  function renderNoRows(){
    return(
        <GridOverlay>
            <div>
                <h6 style={{fontStyle:"italic"}}>No Transactions....</h6>
            </div>
        </GridOverlay>
    )
  }

  function renderNoRows2(){
    return(
        <GridOverlay>
            <div>
                <h6 style={{fontStyle:"italic"}}>No Strategies....</h6>
            </div>
        </GridOverlay>
    )
  }

  function renderNoRowsWithdrawals(){
    return(
        <GridOverlay>
            <div>
                <h6 style={{fontStyle:"italic"}}>No Withdrawal Requests....</h6>
            </div>
        </GridOverlay>
    )
  }

  function changePortfolio(t_id) {
    setPortfolio(t_id);
  }

  function invokeRefresh() {
    setLoading(true);
  }

  function handleOpenWithdrawModal(){
    setWithdrawAmount("");
    setWithdrawError("");
    setWithdrawModalOpen(true);
  }

  function handleCloseWithdrawModal(){
    setWithdrawModalOpen(false);
    setWithdrawAmount("");
    setWithdrawError("");
  }

  function handleWithdrawAmountChange(e){
    const value = e.target.value;
    setWithdrawAmount(value);

    const numValue = parseFloat(value);
    if(isNaN(numValue) || numValue <= 0){
      setWithdrawError("Please enter a valid amount greater than 0.");
    } else if(numValue > withdrawalBalance.cash_balance_raw){
      setWithdrawError(`Amount exceeds available balance of RM ${withdrawalBalance.cash_balance}.`);
    } else {
      setWithdrawError("");
    }
  }

  function handleSubmitWithdrawal(){
    const numValue = parseFloat(withdrawAmount);
    if(isNaN(numValue) || numValue <= 0 || numValue > withdrawalBalance.cash_balance_raw){
      return;
    }
    // TODO: call API to submit withdrawal request
    submitWithdrawalRequest(numValue);
    handleCloseWithdrawModal();
  }

  function handleDeleteWithdrawalRequest(id){
    let resp = window.confirm("Are you sure to delete this withdrawal request?");
    if(resp){
      //call API to delete withdrawal request
      deleteWithdrawalRequest(id);
    }
  }

  function renderDATUpdateTooltip(){
    return(
      <Tooltip title="Updated hourly">
        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
      </Tooltip>
    )
  }

  return (
    <div>
      <Screen
        origin='dashboard'
        setPortfolio={changePortfolio}
        invokeRefresh={invokeRefresh}
      >
        <div style={{textAlign:'center',fontSize:30}}>
          ET SavingsTracker
        </div>
        <br />
        <div className="row justify-content-center px-3">
            {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">Deposits</h3>
                    <h4 className="boldText text-center">RM {deposits}</h4>
                </div>
            </div> */}
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">
                      Net Profit Earned&nbsp;
                      <Tooltip title={
                        <div>
                          Net Profit Earned = Total Profit Earned - (Accrued Management Fees + Accrued Custodian Fees + Bank Charges)
                          <br /><br />
                          You may experience a temporary drop in the Net Profit Earned figure between 11:30 pm to 11:00 am the following day due to daily accruals and profit earned calculations.
                          <br /><br />
                          Daily accruals calculated - 11:30 pm daily.
                          <br /><br />
                          Daily profit earned calculated - 11:00 am daily.
                        </div>
                      }>
                        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
                      </Tooltip>
                    </h3>
                    <h4 className="boldText text-center" style={{ color: parseFloat(String(mmInterest).replace(/,/g, '')) >= 0 ? "green" : "red" }}>RM {mmInterest}</h4>
                </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">
                      Net Cash Balance&nbsp;
                      <Tooltip title={
                        <div>
                          Net Cash Balance = Total Cash Balance + Total Profit Earned - (Accrued Management Fees + Accrued Custodian Fees + Bank Charges)
                          <br /><br />
                          You may experience a temporary drop in the Net Cash Balance figure between 11:30 pm to 11:00 am the following day due to daily accruals and profit earned calculations.
                          <br /><br />
                          Daily accruals calculated - 11:30 pm daily.
                          <br /><br />
                          Daily profit earned calculated - 11:00 am daily.
                        </div>
                      }>
                        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
                      </Tooltip>
                    </h3>
                    <h4 className="boldText text-center">RM {cashBalance}</h4>
                </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">
                      Floating Balance&nbsp;
                      <Tooltip title="Floating balance = Funds received but not yet approved. Approvals are processed Monday to Thursday 9:00 am - 5:00 pm.">
                        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
                      </Tooltip>
                    </h3>
                    <h4 className="boldText text-center">RM {floatingBalance}</h4>
                </div>
            </div>
            {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">Withdrawals</h3>
                    <h4 className="boldText text-center">RM 0.00</h4>
                </div>
            </div> */}

            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
              <div className="aggStatBox">
                <h3 className="boldText mb-3">Gross Profit Logs</h3>
                {/* <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Interest</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2025-01-01</td>
                      <td>RM 100,000.00</td>
                      <td>RM 0.5</td>
                      <td>Interest</td>
                    </tr>
                    <tr>
                      <td>2025-01-02</td>
                      <td>RM 200.00</td>
                      <td>RM 10.00</td>
                      <td>Interest</td>
                    </tr>
                  </tbody>
                </table> */}

                <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20, height: 300 }}>
                  <DataGridPro
                    density="compact"
                    // loading={isLoading}
                    columns={[
                        {
                            field: "reg_date",
                            headerName: "Date",
                            width: 150,
                            align: 'center',
                            headerAlign: 'center',
                            // flex: 1,
                        },
                        {
                            field: "amount",
                            headerName: "Amount",
                            // minWidth: 50,
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        }
                    ]}
                    pagination
                    rows={prepareTableRows()}
                    components={{
                        // Toolbar: renderCustomToolbar,
                        LoadingOverlay: loadingOverlay,
                        NoRowsOverlay: renderNoRows
                    }}  
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
              <div className="aggStatBox">
                <h3 className="boldText mb-3">Strategies</h3>
                {/* <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Strategy Name</th>
                      <th>Client Code</th>
                      <th>Starting Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Snowball</td>
                      <td>SW-A1-2510-10281-1</td>
                      <td>RM 50,000.00</td>
                      <td>Started</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Digital Assets Tracker</td>
                      <td>N/A</td>
                      <td>RM 100,000.00</td>
                      <td>Pending</td>
                    </tr>
                  </tbody>
                </table> */}

                <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20, height: 300 }}>
                  <DataGridPro
                    density="compact"
                    // loading={isLoading}
                    columns={[
                        {
                            field: "strategy_label",
                            headerName: "Strategy Name",
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                            field: "strategy_client_code",
                            headerName: "Client Code",
                            minWidth: 50,
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                          field: "amount",
                          headerName: "Starting Amount",
                          minWidth: 50,
                          flex: 1,
                          align: 'center',
                          headerAlign: 'center',
                        },
                        {
                          field: "strategy_distributed",
                          headerName: "Status",
                          minWidth: 50,
                          flex: 1,
                          align: 'center',
                          headerAlign: 'center',
                        },
                    ]}
                    pagination
                    rows={strategies}
                    components={{
                        // Toolbar: renderCustomToolbar,
                        LoadingOverlay: loadingOverlay,
                        NoRowsOverlay: renderNoRows2
                    }}  
                  />
                </div>

              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
              <div className="aggStatBox">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 className="boldText mb-3">Withdrawal Requests</h3>
                  {withdrawalBalance.cash_balance_raw > 0 && !withdrawalRequests.some(r => r.req_status === "pending") && (
                    <button
                      className="btn btn-danger ml-3"
                      style={{ marginBottom: 12 }}
                      onClick={handleOpenWithdrawModal}
                    >
                      Create Withdrawal Request
                    </button>
                  )}
                </div>

                <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20, height: 300 }}>
                  <DataGridPro
                    density="compact"
                    columns={[
                        {
                            field: "no",
                            headerName: "No.",
                            width: 80,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                            field: "reg_date",
                            headerName: "Date Requested",
                            width: 150,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                            field: "amount",
                            headerName: "Withdrawal Amount",
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                            field: "req_status",
                            headerName: "Status",
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                            valueFormatter: (params) => {
                              if(params.value === "pending"){
                                return "Pending";
                              }else if(params.value === "executed"){
                                return "Withdrawal Completed"
                              }else if(params.value === "failed"){
                                return "Rejected / Failed";
                              }
                            }
                        },
                        {
                            field: "action",
                            headerName: "Action",
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                            renderCell: (params) => {
                              if(params.row.req_status === "pending"){
                                return(
                                  <Tooltip title="Remove withdrawal request">
                                    <IconButton
                                      color="error"
                                      size="small"
                                      onClick={() => {
                                        handleDeleteWithdrawalRequest(params.row.id);
                                      }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                );
                              }
                              else{
                                return(
                                  <span>-</span>
                                );
                              }
                            }
                        },
                    ]}
                    pagination
                    rows={withdrawalRequests}
                    components={{
                        LoadingOverlay: loadingOverlay,
                        NoRowsOverlay: renderNoRowsWithdrawals
                    }}
                  />
                </div>
              </div>
            </div>
        </div>

        {/* Withdrawal Request Modal */}
        <Dialog open={withdrawModalOpen} onClose={handleCloseWithdrawModal} maxWidth="sm" fullWidth>
          <DialogTitle>Create Withdrawal Request</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: 16, marginTop: 8 }}>
              <span style={{ fontSize: 14, color: '#666' }}>
                Available balance for withdrawal: <strong
                  style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => {
                    setWithdrawAmount(String(withdrawalBalance.cash_balance_raw));
                    setWithdrawError("");
                  }}
                >RM {withdrawalBalance.cash_balance}</strong>
              </span>
            </div>
            <TextField
              autoFocus
              label="Amount to Withdraw (RM)"
              type="number"
              fullWidth
              variant="outlined"
              value={withdrawAmount}
              onChange={handleWithdrawAmountChange}
              error={!!withdrawError}
              helperText={withdrawError}
              inputProps={{
                min: 0,
                max: withdrawalBalance.cash_balance_raw,
                step: "0.01"
              }}
            />
          </DialogContent>
          <DialogActions style={{ padding: '16px 24px' }}>
            <button className="btn btn-secondary" onClick={handleCloseWithdrawModal}>
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleSubmitWithdrawal}
              disabled={!withdrawAmount || !!withdrawError}
            >
              Submit Withdrawal Request
            </button>
          </DialogActions>
        </Dialog>

      </Screen>
    </div>
  );
}

export default SavingsPage;
